module.exports = __webpack_public_path__ + "media/images/tmrs_text_01-b7f10d404531f0d55bf6dd7d2e0c2e68.png";